// Use this function only on client side
export function getSearchParams (key: string): string | null {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(key);
}

export function getSearchParamsFromRequestQuery (query: any, key: string): string | null {
  return key && query && query[key]
    ? Array.isArray(query[key]) ? query[key][0] : query[key]
    : null;
}
